import { Button, Divider, Flex, Modal, Stack } from '@mantine/core'
import './UserSubscriptionCard.css'
import moment from 'moment'
import { useContext, useState, useEffect } from 'react'
import AppContext from '../../../contexts/AppContext'
import { IconFaceIdError } from '@tabler/icons-react'
import showNotification from '../../../utils/showNotification'
import axios from 'axios'


export default function UserSubscriptionCard() {

   const { currentUser, setCurrentUser } = useContext(AppContext)
   const subscription = currentUser.subscription
   const IS_INACTIVE = !subscription || !subscription?.is_active

   const [isLoading, setIsLoading] = useState(false)
   const [isConfirmModal, setIsConfirmModal] = useState(false)

   const onConfirmModalFunction = async () => {
      if (!currentUser.email) {
         return showNotification({
            title: "Ha ocurrido un error",
            message: "Por favor, contactate con soporte web"
         });
      }

      const jsonData = {
         user_email: currentUser.email,
         is_campus: true
      };

      setIsLoading(true);

      const URL = `${process.env.REACT_APP_BACKEND_SERVER}payment/subscription/cancel`;

      try {
         await axios.put(URL, jsonData);

         showNotification({
            title: 'Operación exitosa',
            message: "Ya has sido desvinculado del plan.",
            color: "green",
            status: "success",
            autoClose: 5000
         });

         const subscription = {
            type: null,
            endDate: moment().toDate(),
            is_active: false,
         }
         setCurrentUser(prev => ({ ...prev, subscription }))
         setIsConfirmModal(false)
      } catch (error) {
         console.log(error);
         showNotification({
            color: "red",
            status: "error",
            title: "Ha ocurrido un error.",
            message: `Detalle: ${error?.message || "Contactate con soporte"}`,
            autoClose: 12000
         });
         setIsLoading(false);
      }
   };



   return (
      <>
         {isConfirmModal && <Modal opened={isConfirmModal} onClose={() => setIsConfirmModal(false)}

         >
            <Stack align='center'>
               <IconFaceIdError size={80} />
               <p className='UserSubscriptionCard--confirmModalText' >Te vamos a extrañar {currentUser.name}<br />
                  ¿Estás seguro que queres darte de baja al plan actual?</p>

               <Divider w='100%' color='#00000032' />

               <p className='UserSubscriptionCard--confirmModalText--sm' >En caso de continuar, te vamos a redirigir a otra página para completar la acción</p>

               <Flex w='100%' justify='center' gap={16}>
                  <Button variant='outline' onClick={() => setIsConfirmModal(false)} type='button'>Volver</Button>
                  <Button variant='outline' onClick={onConfirmModalFunction} color='red' type='button'>Continuar</Button>
               </Flex>
            </Stack>

         </Modal>}
         <div className='UserSubscriptionCard-main-container'>
            <h4 className='UserSubscriptionCard--titleCard'>
               {IS_INACTIVE ? "¿Todavía no te has suscripto a la comunidad?" : "Tu suscripción de la comunidad está activa"}
            </h4>
            {!IS_INACTIVE
               ? <div className='UserSubscriptionCard-column-container'>
                  <span>Desde: {moment(subscription.startDate).format("D [de] MMMM [de] YYYY")}</span>
                  <span>Válida hasta: {moment(subscription.endDate).format("D [de] MMMM [de] YYYY")}</span>
                  <Button onClick={() => setIsConfirmModal(true)} style={{ textDecoration: "underline" }} color='#ffffffe0' variant='transparent' type='button'>Quiero darme de baja</Button>
               </div>
               : <div className='UserSubscriptionCard-column-container'>
                  <p>
                     ¡No te pierdas de nada! <br /> Accedé a la comunidad sin límites
                  </p>
                  <Button
                     component='a'
                     href='https://forvet.org/comunidad'
                     target='_blank'
                     variant='light'
                     color='#FF7BAC'
                  >
                     Ver planes
                  </Button>
               </div>
            }
         </div>
      </>

   )
}
